<template>
    <div class="checkbox-group">
        <kgr-checkbox
            v-for="(option, index) in options"
            :key="index"
            :checked="checked(option)"
            :label="buildLabel(option)"
            :inline="inline"
            :class="{ 'inline-checkbox': inline, 'block-checkbox': !inline }"
            :inactive="inactive"
            :info="buildInfo(option)"
            @change="change(option, $event)"
        />
        <slot></slot>
    </div>
</template>

<script>
import Checkbox from './Checkbox.vue';

export default {
    components: {
        'kgr-checkbox': Checkbox,
    },
    props: {
        options: {
            type: Array,
            required: true,
        },
        value: {
            type: Array,
            required: true,
        },
        labelPrefix: {
            type: String,
            required: false,
            default: '',
        },
        fieldForLabel: {
            type: String,
            required: false,
            default: null
        },
        fieldForInfo: {
            type: String,
            required: false,
            default: null
        },
        inline: {
            type: Boolean,
            require: false,
            default: false,
        },
        inactive: {
            type: Boolean,
            require: false,
            default: false,
        },
    },
    methods: {
        buildInfo(option) {
            if(null !== this.fieldForInfo) {
                return option[this.fieldForInfo];
            }
            return '';
        },
        buildLabel(option) {
            if(null !== this.fieldForLabel) {
                return option[this.fieldForLabel];
            }
            return this.$t(this.labelPrefix + '.' + option)
        },
        checked(option) {
            return this.value.indexOf(option) !== -1;
        },
        change(option, checked) {
            let newValue = this.value;
            if (checked) {
                newValue.push(option);
            } else {
                newValue.splice(this.value.indexOf(option), 1);
            }
            this.$emit('input', newValue);
            this.$nextTick(() => {
                this.$emit('post-input', newValue);
            });
        },
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .checkbox-group {
        margin-bottom: -4px;
    }
    .block-checkbox {
        margin:2px 0;
    }
</style>
